/* eslint no-use-before-define: 0 */

import { request, requestConfig } from 'utils/request.js';

import {
    FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE, FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE_SUCCESS, FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE_FAILURE,
    FETCH_CONTENT, FETCH_CONTENT_SUCCESS, FETCH_CONTENT_FAILURE,
    REMOVE_CONTENT, REMOVE_CONTENT_SUCCESS, REMOVE_CONTENT_FAILURE,
    SAVE_CONTENT, SAVE_CONTENT_SUCCESS, SAVE_CONTENT_FAILURE,
    CLEAR_CONTENT_TO_PREVIEW, CLEAR_CONTENT_SINGLE, EMPTY_CONTENT, SET_CONTENT_SINGLE, SET_CONTENT_PIECE_TO_PREVIEW, SET_CONTENT_SET_TO_PREVIEW,
    UPDATE_CONTENT, UPDATE_SEARCH_TERM, UPDATE_FILE_TO_UPLOAD
} from './constants';

import { PATHS } from 'utils/paths';

const fetchAssignmentsForContentPiece = () => ({
    type: FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE
});

const fetchAssignmentsForContentPieceSuccess = () => ({
    type: FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE_SUCCESS
});

const fetchAssignmentsForContentPieceFailure = (error) => ({
    type: FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE_FAILURE,
    error
});

const fetchContent = () => ({
    type: FETCH_CONTENT
});

const fetchContentSuccess = (data) => ({
    type: FETCH_CONTENT_SUCCESS,
    data
});

const fetchContentFailure = (error) => ({
    type: FETCH_CONTENT_FAILURE,
    error
});

const removeContent = () => ({
    type: REMOVE_CONTENT
});

const removeContentSuccess = () => ({
    type: REMOVE_CONTENT_SUCCESS
});

const removeContentFailure = (error) => ({
    type: REMOVE_CONTENT_FAILURE,
    error
});

const saveContent = () => ({
    type: SAVE_CONTENT
});

const saveContentSuccess = (data) => ({
    type: SAVE_CONTENT_SUCCESS,
    data
});

const saveContentFailure = (error) => ({
    type: SAVE_CONTENT_FAILURE,
    error
});

export const clearContentToPreview = () => ({
    type: CLEAR_CONTENT_TO_PREVIEW
});

export const clearContentSingle = () => ({
    type: CLEAR_CONTENT_SINGLE
});

export const emptyContent = () => ({
    type: EMPTY_CONTENT
});

export const setContentSingle = (data) => ({
    type: SET_CONTENT_SINGLE,
    data
});

export const setContentPieceToPreview = (data) => ({
    type: SET_CONTENT_PIECE_TO_PREVIEW,
    data
});

export const setContentSetToPreview = (data) => ({
    type: SET_CONTENT_SET_TO_PREVIEW,
    data
});
export const updateContent = (data) => ({
    type: UPDATE_CONTENT,
    data
});

export const updateSearchTerm = (data) => ({
    type: UPDATE_SEARCH_TERM,
    data
});

export const updateFileToUpload = (data) => ({
    type: UPDATE_FILE_TO_UPLOAD,
    data
});






/**
 *  ASYNC ACTIONS
 */

export const deleteContent = (callback) => (dispatch, getState) => {
    dispatch(removeContent());
    let contentPiece = getState().content.single;
    request(PATHS.content.putContent(contentPiece.id), requestConfig('DELETE'))
        .then(() => {
            // Loop through all existing content to see if this user exists. If so, remove it
            let allContent = getState().content.all;
            for(var i = 0, l = allContent.length; i < l; i++) {
                if(allContent[i].id === contentPiece.id) {
                    allContent.splice(i, 1);
                    break;
                }

            }
            dispatch(removeContentSuccess());
            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            dispatch(removeContentFailure(error));
        })
};

export const getAssignmentsAndSetContentSingle = (contentPiece) => (dispatch) => {
    dispatch(setContentSingle(contentPiece));
    dispatch(fetchAssignmentsForContentPiece());

    let completedCount = 0;
    let assignments = [];
    contentPiece.assignmentIds.forEach((id) => {
        request(PATHS.assignments.getAssignment(id), requestConfig('GET'))
            .then((assignment) => {
                completedCount++;
                assignments.push(assignment);
                if(completedCount === contentPiece.assignmentIds.length) {
                    contentPiece.assignments = assignments;
                    dispatch(fetchAssignmentsForContentPieceSuccess());
                    dispatch(setContentSingle(contentPiece));
                }
            })
            .catch((error) => {
                console.log('error getting assignment', error);
                dispatch(fetchAssignmentsForContentPieceFailure(error));
            });
    });
};

export const getContent = (callback) => (dispatch, getState) => {
    if(getState().content.isFetching === true) {
        return;
    }

    dispatch(fetchContent());

    let contentState = getState().content;
    let path = '';
    let pageNumber = contentState.pageNumber + 1;

    if(contentState.searchTerm !== '') {
        path = PATHS.content.getContent.search(contentState.searchTerm, pageNumber, contentState.pageSize);
    } else {
        let userId = getState().auth.user.id;
        path = PATHS.content.getContent.filtered(contentState.filterBy, contentState.sortBy, contentState.sortDirection, pageNumber, contentState.pageSize, userId);
    }

    return request(path, requestConfig('GET'))
        .then((data) => {
            dispatch(fetchContentSuccess(data));
            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            console.log(error);
            dispatch(fetchContentFailure(error));
        });
};

export const postContentFile = (callback) => (dispatch, getState) => {
    dispatch(saveContent());

    let file = getState().content.fileToUpload;

    if(file.blob != null) {
        delete file.blob;
    }

    let xhr = new XMLHttpRequest();
    let formData = new FormData();
    formData.append('file', file);

    xhr.open("POST", PATHS.upload.file(), true);
    xhr.withCredentials = true;
    xhr.setRequestHeader('Accept', 'application/json');

    // Get the thumbnail elements.
    // TODO: This will need to be boilerplated somehow
    let progressBarEl = document.getElementById('thumbnailProgress'),
        progressBarWrapperEl = document.querySelector('.thumbnail-drop__progress--outer'),
        progressOverlayEl = document.querySelector('.thumbnail-drop__progress--overlay'),
        progressDoneEl = document.querySelector('.thumbnail-drop__progress--done');

    xhr.upload.onprogress = function (event) {
        if (event.lengthComputable) {
            var progress = Math.floor((event.loaded / event.total) * 100);
            //console.log('progress = ' + progress);
            if(progressBarEl != null) {
                progressBarEl.style.width = progress + '%';
            }
        }
    };
    xhr.upload.onloadstart = function (event) {
        if(progressBarEl != null && progressOverlayEl != null && progressBarWrapperEl != null) {
            progressBarEl.style.width = '0%';
            progressOverlayEl.style.display = 'block';
            progressBarWrapperEl.style.display = 'block';
        }
    };
    xhr.upload.onloadend = function (event) {
        //console.log('progress = 100% done');
        if(progressBarWrapperEl != null && progressDoneEl != null && progressOverlayEl != null) {
            setTimeout(function () {
                progressBarWrapperEl.style.display = 'none';
                progressDoneEl.style.display = 'block';
            }, 250);
            setTimeout(function () {
                progressOverlayEl.style.display = 'none';
                progressDoneEl.style.display = 'none';
            }, 750);
        }
    };
    xhr.onreadystatechange = function() {
        if(xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
            let contentPiece = getState().content.single;
            contentPiece.file = JSON.parse(xhr.responseText);
            dispatch(setContentSingle(contentPiece));
            dispatch(postPutContent(callback));
        } else {
            dispatch(saveContentFailure({status: 404, friendlyMessage: 'There was an error saving your file.'}));
        }
    };
    xhr.send(formData);
};

export const postPutContent = (callback) => (dispatch, getState) => {
    dispatch(saveContent());

    let contentPiece = getState().content.single;
    let method = 'POST';

    let path = PATHS.content.postContent();

    if(contentPiece.id != null) {
        method = 'PUT';
        path = PATHS.content.putContent(contentPiece.id);
    }

    request(path, requestConfig(method, contentPiece))
        .then((newContentPiece) => {

            dispatch(saveContentSuccess(newContentPiece));

            if(method === 'PUT' && getState().users.sortBy !== 'modified') { // I'm intentionally excluding modified here, because the content piece will go at the top, if they are not already
                // Loop through all existing content to see if this content piece exists. If so, replace it in the array
                let allContent = getState().content.all;
                for(var i = 0, l = allContent.length; i < l; i++) {
                    if(allContent[i].id === newContentPiece.id) {
                        allContent[i] = newContentPiece;
                        break;
                    }
                }
            } else {
                //If it's a new content piece, then get all content again
                let content = getState().content;
                content.pageNumber = 0;
                content.hasMore = true;
                content.all = [];
                dispatch(updateContent(content));
                dispatch(getContent());
                dispatch(updateFileToUpload(null));
            }

            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            dispatch(saveContentFailure(error));
        });
};

export const uploadChecklistThumbnail = (file, callback) => (dispatch, getState) => {
    let xhr = new XMLHttpRequest();
    let formData = new FormData();
    formData.append('file', file);

    xhr.open("POST", PATHS.upload.thumbnail(), true);
    xhr.withCredentials = true;
    xhr.setRequestHeader('Accept', 'application/json');

    // Get the thumbnail elements.
    // TODO: This will need to be boilerplated somehow

    xhr.upload.onprogress = function (event) {
        if (event.lengthComputable) {
            var progress = Math.floor((event.loaded / event.total) * 100);
            console.log('progress = ' + progress);
        }
    };
    xhr.upload.onloadend = function (event) {
        console.log('progress = 100% done');
    };
    xhr.onreadystatechange = function() {
        if(xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
            callback(JSON.parse(xhr.responseText));
        } else {
            dispatch(saveContentFailure({status: 404, friendlyMessage: 'There was an error saving your file.'}));
        }
    };
    xhr.send(formData);
};

export const uploadThumbnailsAndPostPutChecklist = (callback) => (dispatch, getState) => {
    dispatch(saveContent());
    console.log(callback)

    let contentPiece = getState().content.single;

    let imagesToUpload = [];

    if(contentPiece.thumbnail && contentPiece.thumbnail.id == null) {
        imagesToUpload.push({
            file: contentPiece.thumbnail,
            type: 'main'
        });
    }

    contentPiece.items.forEach((item, index) => {
        if(item.thumbnail && item.thumbnail.id == null) {
            imagesToUpload.push({
                file: item.thumbnail,
                type: 'item',
                index: index
            });
        }
    });

    if(imagesToUpload.length === 0) {
        dispatch(postPutContent(callback));
    } else {
        let uploadCount = 0;
        imagesToUpload.forEach((img) => {
            dispatch(uploadChecklistThumbnail(img.file, (uploadResponse) => {
                if(img.type === 'main') {
                    contentPiece.thumbnail = uploadResponse;
                } else {
                    contentPiece.items[img.index].thumbnail = uploadResponse;
                }

                uploadCount++;
                if(uploadCount === imagesToUpload.length) {
                    dispatch(setContentSingle(contentPiece));
                    setTimeout(() => dispatch(postPutContent(callback)), 1);
                }
            }))
        });
    }
};



// WEBPACK FOOTER //
// ./src/containers/ContentPage/store/actions.js